var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createReducer } from "redux-act";
import { signOutStart } from "../auth/auth.actions";
import * as actions from "./propertyAmenity.actions";
var getDefaultState = function () { return ({
    byPropertyId: {},
}); };
var reducer = createReducer({}, getDefaultState());
reducer.on(signOutStart.type, function () { return getDefaultState(); });
reducer.on(actions.getByPropertyIdStart, function (state, payload) {
    var _a;
    var _b;
    return (__assign(__assign({}, state), { byPropertyId: __assign(__assign({}, state.byPropertyId), (_a = {}, _a[payload.propertyId] = __assign(__assign({}, state.byPropertyId[payload.propertyId]), { items: ((_b = state.byPropertyId[payload.propertyId]) === null || _b === void 0 ? void 0 : _b.items) || [], isFetching: true, fetchError: undefined }), _a)) }));
});
reducer.on(actions.getByPropertyIdSucceeded, function (state, payload) {
    var _a;
    return (__assign(__assign({}, state), { byPropertyId: __assign(__assign({}, state.byPropertyId), (_a = {}, _a[payload.propertyId] = {
            items: payload.items,
            isFetching: false,
            fetchError: undefined,
        }, _a)) }));
});
reducer.on(actions.getByPropertyIdFailed, function (state, payload) {
    var _a;
    var _b;
    return (__assign(__assign({}, state), { byPropertyId: __assign(__assign({}, state.byPropertyId), (_a = {}, _a[payload.propertyId] = __assign(__assign({}, state.byPropertyId[payload.propertyId]), { items: ((_b = state.byPropertyId[payload.propertyId]) === null || _b === void 0 ? void 0 : _b.items) || [], isFetching: false, fetchError: payload.error }), _a)) }));
});
// eslint-disable-next-line import/no-default-export
export default reducer;
